import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import StatsPanelItem from 'components/stats-panel-item';
import { Tooltip } from '@99designs/common/components/Tooltip';

export default class ResponsivenessScoreStatsPanelItem extends React.Component {
    formatScore() {
        return this.props.score * 0.01;
    }

    message() {
        return (
            <Tooltip
                tooltip={__(
                    'Percentage of 1-to-1 Project invitations responded to within 24 hours'
                )}
            >
                {this.statsPanelItem()}
            </Tooltip>
        );
    }

    statsPanelItem() {
        return (
            <StatsPanelItem
                value={<FormattedNumber style={'percent'} value={this.formatScore()} />}
                title={__('Responses within 24h')}
            />
        );
    }

    render() {
        if (this.props.score !== null) {
            return <span>{this.message()}</span>;
        }
        return null;
    }
}

ResponsivenessScoreStatsPanelItem.propTypes = {
    score: PropTypes.number,
};

ResponsivenessScoreStatsPanelItem.defaultProps = {
    score: null,
};



// WEBPACK FOOTER //
// ./src/js/apps/responsiveness-score/components/responsiveness-score-stats-panel-item.jsx